import { Attr, IndexedMesh } from "./indexed-mesh";
import { IndexedMeshWriter } from "./indexed-mesh-writer";


type QuadAttrs = {
    normal: Attr,
    uv: Attr;
}

export class Quad extends IndexedMeshWriter<QuadAttrs> {

    x: number;
    y: number;
    width: number;
    height: number;

    constructor(x: number, y: number, width: number, height: number) {
        super();
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }

    computeAttributeCounts(): IndexedMesh<QuadAttrs> {
        const mesh = new IndexedMesh({
            normal: new Attr(3),
            uv: new Attr(2),
        });

        mesh.index.count = 6;
        mesh.position.count = 4;
        mesh.attrs.normal.count = 4;
        mesh.attrs.uv.count = 4;

        return mesh;
    }

    computeMeshData(mesh: IndexedMesh<QuadAttrs>) {
        const
            x = this.x,
            y = this.y,
            width = this.width,
            height = this.height,
            idx = mesh.index.data,
            pos = mesh.position.data,
            norm = mesh.attrs.normal.data,
            uv = mesh.attrs.uv.data;

        idx[0] = 0; idx[1] = 1; idx[2] = 2;
        idx[3] = 0; idx[4] = 2; idx[5] = 3;

        // counter-clockwise from the origin at bottom left
        pos[0] = x;       pos[1]  = y;        pos[2]  = 0;
        pos[3] = x+width; pos[4]  = y;        pos[5]  = 0;
        pos[6] = x+width; pos[7]  = y+height; pos[8]  = 0;
        pos[9] = x;       pos[10] = y+height; pos[11] = 0;

        norm[0] = 0; norm[1]  = 0; norm[2]  = 1;
        norm[3] = 0; norm[4]  = 0; norm[5]  = 1;
        norm[6] = 0; norm[7]  = 0; norm[8]  = 1;
        norm[9] = 0; norm[10] = 0; norm[11] = 1;

        uv[0] = pos[0]; uv[1] = pos[1];
        uv[2] = pos[3]; uv[3] = pos[4];
        uv[4] = pos[6]; uv[5] = pos[7];
        uv[6] = pos[9]; uv[7] = pos[10];
    }
};
